import { useTranslation } from 'react-i18next';

import { CodeBlock } from './CodeBlock';
import InfoBlock from './InfoBlock';

type PropsGeneralErrorInfo = {
  sentryId?: string;
  errorObj: Error;
  showFullErrMsg?: boolean;
};

export default function GeneralErrorInfo({
  sentryId,
  errorObj,
  showFullErrMsg = false,
}: PropsGeneralErrorInfo) {
  const { t } = useTranslation();

  return (
    <>
      <CodeBlock className="mb-4">
        {`${t('shared:dialog.unexpected_err.label.log_id', {
          defaultValue: `Log ID`,
        })}: ${sentryId}`}
      </CodeBlock>
      <InfoBlock
        rows={[]}
        additionalMessage={showFullErrMsg ? errorObj.message : undefined}
      />
    </>
  );
}
